import React, { Fragment } from "react";
import { InvitedExpert, Participant } from "../../core/api/model";
import { DashboardExpertsListItem, DashboardInvitedExpertsListItem, DashboardExpertsListEmpty } from ".";

export interface DashboardExpertsListProps {
  experts: Participant[];
  invitedExperts: InvitedExpert[];
  deleteExpert: (expert: Participant) => void;
}

export const DashboardExpertsList = (props: DashboardExpertsListProps) => {

  return (
    <Fragment>
      {props.experts.length > 0 || props.invitedExperts.length > 0 ? (
        // list
        <Fragment>
          {props.experts.map((expert: Participant) => 
            <DashboardExpertsListItem key={expert.partId} expert={expert} deleteExpert={props.deleteExpert}/>
          )}
          {props.invitedExperts.map((invitedExpert: InvitedExpert) => 
            <DashboardInvitedExpertsListItem key={invitedExpert.email} invitedExpert={invitedExpert} />
          )}
        </Fragment>
      ) :
        // empty
        <DashboardExpertsListEmpty />
      }
    </Fragment>
  );
};
